/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import MeRepository from '../../../helpers/api/MeRepository';

export default class CompanyComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: []
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];

    try {
      items = await MeRepository.getCompanies();
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxCompany"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a Company"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.code.toLowerCase().includes(inputValue.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
        selectedItem={this.props.selectedItem}
      />
    );
  }
}

CompanyComboBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
CompanyComboBox.defaultProps = {
  selectedItem: null,
  disabled: true
};
